// 9fbef606107a605d69c0edbcd8029e5d
const EMAIL_CONFIRMATION_CONSTANTS = {
  EMAIL_CONFIRMATION_REQUEST: `EMAIL_CONFIRMATION_REQUEST`,
  EMAIL_CONFIRMATION_FAILED: `EMAIL_CONFIRMATION_FAILED`,
  EMAIL_CONFIRMATION_SUCCESS: `EMAIL_CONFIRMATION_SUCCESS`,
  RESET_EMAIL_CONFIRMATION: `RESET_EMAIL_CONFIRMATION`,
  EMAIL_ADDRESS_SAME: `EMAIL_ADDRESS_SAME`,
  ACCOUNT_HOLD: 'ACCOUNT_HOLD',
  SET_EMAIL_CONFIRMATION_LOADER: 'SET_EMAIL_CONFIRMATION_LOADER',
  VICTIM_ALREADY_MERGED_STATUS: 'Merged',
  EMAIL_NOT_FOUND: 'ERR_USER_NOT_FOUND',
};

export default EMAIL_CONFIRMATION_CONSTANTS;
